var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("button", { attrs: { id: "print-button", onclick: "window.print()" } }, [
      _vm._v("Print me!")
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "page" }, [
      _c("div", { staticClass: "subpage" }, [
        _c("div", { staticClass: "row char-sheet-header-block" }, [
          _c("div", { staticClass: "col-5", attrs: { id: "char-name" } }, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                {
                  staticClass: "col-12 input-section",
                  attrs: { id: "char-name-text" }
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.sheet.character_name,
                        expression: "sheet.character_name"
                      }
                    ],
                    domProps: { value: _vm.sheet.character_name },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.sheet,
                          "character_name",
                          $event.target.value
                        )
                      }
                    }
                  })
                ]
              )
            ]),
            _vm._v(" "),
            _vm._m(0)
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-7" }, [
            _c("div", { staticClass: "row char-info-input-row" }, [
              _c("div", { staticClass: "col-4 input-section" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.sheet.class_and_level,
                      expression: "sheet.class_and_level"
                    }
                  ],
                  domProps: { value: _vm.sheet.class_and_level },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.sheet,
                        "class_and_level",
                        $event.target.value
                      )
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-4 input-section" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.sheet.background,
                      expression: "sheet.background"
                    }
                  ],
                  domProps: { value: _vm.sheet.background },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.sheet, "background", $event.target.value)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-4 input-section" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.sheet.player_name,
                      expression: "sheet.player_name"
                    }
                  ],
                  domProps: { value: _vm.sheet.player_name },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.sheet, "player_name", $event.target.value)
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "row char-info-input-row" }, [
              _c("div", { staticClass: "col-4 input-section" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.sheet.race,
                      expression: "sheet.race"
                    }
                  ],
                  domProps: { value: _vm.sheet.race },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.sheet, "race", $event.target.value)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-4 input-section" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.sheet.alignment,
                      expression: "sheet.alignment"
                    }
                  ],
                  domProps: { value: _vm.sheet.alignment },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.sheet, "alignment", $event.target.value)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-4 input-section" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.sheet.experience_points,
                      expression: "sheet.experience_points"
                    }
                  ],
                  domProps: { value: _vm.sheet.experience_points },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.sheet,
                        "experience_points",
                        $event.target.value
                      )
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _vm._m(2)
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row char-sheet" }, [
          _c("div", { staticClass: "col-4 left-column" }, [
            _c("div", { staticClass: "row abilities-and-skills-block" }, [
              _c("div", { staticClass: "col-12" }, [
                _c(
                  "div",
                  { staticClass: "row abilities-and-skills-container" },
                  [
                    _c("div", { staticClass: "col-12" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-4 ability-scores-col" }, [
                          _c(
                            "div",
                            { staticClass: "row" },
                            _vm._l(_vm.sheet.ability_scores, function(
                              abi_score
                            ) {
                              return _c(
                                "div",
                                {
                                  key: abi_score.name,
                                  staticClass: "col-12 ability",
                                  attrs: { value: abi_score.name }
                                },
                                [
                                  _c("div", { staticClass: "row" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col-12 ability-label" },
                                      [_vm._v(_vm._s(abi_score.name))]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "row" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col-12 input-section" },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: abi_score.score,
                                              expression: "abi_score.score"
                                            }
                                          ],
                                          domProps: { value: abi_score.score },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                abi_score,
                                                "score",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        })
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "row" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col-12 input-section" },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: abi_score.bonus,
                                              expression: "abi_score.bonus"
                                            }
                                          ],
                                          domProps: { value: abi_score.bonus },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                abi_score,
                                                "bonus",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        })
                                      ]
                                    )
                                  ])
                                ]
                              )
                            }),
                            0
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-8 skills-col" }, [
                          _c("div", { staticClass: "row inspiration" }, [
                            _c("div", { staticClass: "col-2" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.sheet.inspiration,
                                    expression: "sheet.inspiration"
                                  }
                                ],
                                attrs: { type: "checkbox" },
                                domProps: {
                                  checked: Array.isArray(_vm.sheet.inspiration)
                                    ? _vm._i(_vm.sheet.inspiration, null) > -1
                                    : _vm.sheet.inspiration
                                },
                                on: {
                                  change: function($event) {
                                    var $$a = _vm.sheet.inspiration,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.sheet,
                                            "inspiration",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.sheet,
                                            "inspiration",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(_vm.sheet, "inspiration", $$c)
                                    }
                                  }
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-10" }, [
                              _vm._v("Inspiration")
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row proficiency-bonus" }, [
                            _c("div", { staticClass: "col-2 input-section" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.sheet.proficiency_bonus,
                                    expression: "sheet.proficiency_bonus"
                                  }
                                ],
                                domProps: {
                                  value: _vm.sheet.proficiency_bonus
                                },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.sheet,
                                      "proficiency_bonus",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-10" }, [
                              _vm._v("Proficiency Bonus")
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row saving-throws" }, [
                            _c(
                              "div",
                              { staticClass: "col-12" },
                              [
                                _vm._l(_vm.sheet.saving_throws, function(save) {
                                  return _c(
                                    "div",
                                    {
                                      key: save.abi,
                                      staticClass: "row saving-throw",
                                      attrs: { value: save.abi }
                                    },
                                    [
                                      _c("div", { staticClass: "col-2" }, [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: save.proficient,
                                              expression: "save.proficient"
                                            }
                                          ],
                                          attrs: { type: "checkbox" },
                                          domProps: {
                                            checked: Array.isArray(
                                              save.proficient
                                            )
                                              ? _vm._i(save.proficient, null) >
                                                -1
                                              : save.proficient
                                          },
                                          on: {
                                            change: function($event) {
                                              var $$a = save.proficient,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    _vm.$set(
                                                      save,
                                                      "proficient",
                                                      $$a.concat([$$v])
                                                    )
                                                } else {
                                                  $$i > -1 &&
                                                    _vm.$set(
                                                      save,
                                                      "proficient",
                                                      $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        )
                                                    )
                                                }
                                              } else {
                                                _vm.$set(
                                                  save,
                                                  "proficient",
                                                  $$c
                                                )
                                              }
                                            }
                                          }
                                        })
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "col-2 input-section" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: save.bonus,
                                                expression: "save.bonus"
                                              }
                                            ],
                                            domProps: { value: save.bonus },
                                            on: {
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  save,
                                                  "bonus",
                                                  $event.target.value
                                                )
                                              }
                                            }
                                          })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "col-8" }, [
                                        _vm._v(
                                          _vm._s(_vm.ABI_SCORES_MAP[save.abi])
                                        )
                                      ])
                                    ]
                                  )
                                }),
                                _vm._v(" "),
                                _vm._m(3)
                              ],
                              2
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row skills" }, [
                            _c(
                              "div",
                              { staticClass: "col-12" },
                              [
                                _vm._l(_vm.sheet.skills, function(skill) {
                                  return _c(
                                    "div",
                                    {
                                      key: skill.skill,
                                      staticClass: "row skill",
                                      attrs: { value: skill.skill }
                                    },
                                    [
                                      _c("div", { staticClass: "col-2" }, [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: skill.proficient,
                                              expression: "skill.proficient"
                                            }
                                          ],
                                          attrs: { type: "checkbox" },
                                          domProps: {
                                            checked: Array.isArray(
                                              skill.proficient
                                            )
                                              ? _vm._i(skill.proficient, null) >
                                                -1
                                              : skill.proficient
                                          },
                                          on: {
                                            change: function($event) {
                                              var $$a = skill.proficient,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    _vm.$set(
                                                      skill,
                                                      "proficient",
                                                      $$a.concat([$$v])
                                                    )
                                                } else {
                                                  $$i > -1 &&
                                                    _vm.$set(
                                                      skill,
                                                      "proficient",
                                                      $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        )
                                                    )
                                                }
                                              } else {
                                                _vm.$set(
                                                  skill,
                                                  "proficient",
                                                  $$c
                                                )
                                              }
                                            }
                                          }
                                        })
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "col-2 input-section" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: skill.bonus,
                                                expression: "skill.bonus"
                                              }
                                            ],
                                            domProps: { value: skill.bonus },
                                            on: {
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  skill,
                                                  "bonus",
                                                  $event.target.value
                                                )
                                              }
                                            }
                                          })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "col-8" }, [
                                        _vm._v(
                                          _vm._s(skill.skill) +
                                            "(" +
                                            _vm._s(skill.abi) +
                                            ")"
                                        )
                                      ])
                                    ]
                                  )
                                }),
                                _vm._v(" "),
                                _vm._m(4)
                              ],
                              2
                            )
                          ])
                        ])
                      ])
                    ])
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row passive-perception-block" }, [
              _c("div", { staticClass: "col-12" }, [
                _c("div", { staticClass: "row passive-perception-container" }, [
                  _c("div", { staticClass: "col-2 input-section" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.sheet.passive_perception,
                          expression: "sheet.passive_perception"
                        }
                      ],
                      domProps: { value: _vm.sheet.passive_perception },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.sheet,
                            "passive_perception",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-10" }, [
                    _vm._v("Passive Perception")
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "row proficiencies-and-languages-block" },
              [
                _c("div", { staticClass: "col-12" }, [
                  _c(
                    "div",
                    {
                      staticClass: "row proficiencies-and-languages-container"
                    },
                    [
                      _c("div", { staticClass: "col-12" }, [
                        _c(
                          "div",
                          { staticClass: "row proficiencies-and-languages" },
                          [
                            _c("div", { staticClass: "col text-section" }, [
                              _c("textarea", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.sheet.other_profs_and_langs,
                                    expression: "sheet.other_profs_and_langs"
                                  }
                                ],
                                domProps: {
                                  value: _vm.sheet.other_profs_and_langs
                                },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.sheet,
                                      "other_profs_and_langs",
                                      $event.target.value
                                    )
                                  }
                                }
                              }),
                              _vm._v(
                                "\n                      Other Proficiencies & Languages\n                    "
                              )
                            ])
                          ]
                        )
                      ])
                    ]
                  )
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-4 middle-column" }, [
            _c("div", { staticClass: "row vitals-block" }, [
              _c("div", { staticClass: "col-12" }, [
                _c("div", { staticClass: "row vitals-container" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c("div", { staticClass: "row ac-init-speed" }, [
                      _c("div", { staticClass: "col-4 ac" }, [
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-12 input-section" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.sheet.ac,
                                  expression: "sheet.ac"
                                }
                              ],
                              domProps: { value: _vm.sheet.ac },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(_vm.sheet, "ac", $event.target.value)
                                }
                              }
                            })
                          ])
                        ]),
                        _vm._v(" "),
                        _vm._m(5)
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-4 init" }, [
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-12 input-section" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.sheet.initiative,
                                  expression: "sheet.initiative"
                                }
                              ],
                              domProps: { value: _vm.sheet.initiative },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.sheet,
                                    "initiative",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          ])
                        ]),
                        _vm._v(" "),
                        _vm._m(6)
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-4 speed" }, [
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-12 input-section" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.sheet.speed,
                                  expression: "sheet.speed"
                                }
                              ],
                              domProps: { value: _vm.sheet.speed },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.sheet,
                                    "speed",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          ])
                        ]),
                        _vm._v(" "),
                        _vm._m(7)
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row hp" }, [
                      _c("div", { staticClass: "col-12" }, [
                        _c("div", { staticClass: "row hp-max" }, [
                          _c("div", { staticClass: "col-5" }, [
                            _vm._v("Hit Point Maximum")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-7 input-section" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.sheet.hp_max,
                                  expression: "sheet.hp_max"
                                }
                              ],
                              domProps: { value: _vm.sheet.hp_max },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.sheet,
                                    "hp_max",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row hp-current-input" }, [
                          _c("div", { staticClass: "col-12 input-section" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.sheet.hp_current,
                                  expression: "sheet.hp_current"
                                }
                              ],
                              domProps: { value: _vm.sheet.hp_current },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.sheet,
                                    "hp_current",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          ])
                        ]),
                        _vm._v(" "),
                        _vm._m(8)
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row temp-hp" }, [
                      _c("div", { staticClass: "col-12" }, [
                        _c("div", { staticClass: "row temp-hp-input" }, [
                          _c("div", { staticClass: "col-12 input-section" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.sheet.hp_temp,
                                  expression: "sheet.hp_temp"
                                }
                              ],
                              domProps: { value: _vm.sheet.hp_temp },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.sheet,
                                    "hp_temp",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          ])
                        ]),
                        _vm._v(" "),
                        _vm._m(9)
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row hit-dice-and-death-saves" }, [
                      _c("div", { staticClass: "col-6 hit-dice" }, [
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-3" }, [
                            _vm._v("Total")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-9 input-section" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.sheet.hit_dice_total,
                                  expression: "sheet.hit_dice_total"
                                }
                              ],
                              domProps: { value: _vm.sheet.hit_dice_total },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.sheet,
                                    "hit_dice_total",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-12 input-section" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.sheet.hit_dice_current,
                                  expression: "sheet.hit_dice_current"
                                }
                              ],
                              domProps: { value: _vm.sheet.hit_dice_current },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.sheet,
                                    "hit_dice_current",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          ])
                        ]),
                        _vm._v(" "),
                        _vm._m(10)
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-6 death-saves" }, [
                        _c(
                          "div",
                          { staticClass: "row" },
                          [
                            _c("div", { staticClass: "col-6" }, [
                              _vm._v("Successes")
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.sheet.death_saves.successes, function(
                              success
                            ) {
                              return _c(
                                "div",
                                {
                                  key: success.state,
                                  staticClass: "col-2 death-save"
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: success.state,
                                        expression: "success.state"
                                      }
                                    ],
                                    attrs: { type: "checkbox" },
                                    domProps: {
                                      checked: Array.isArray(success.state)
                                        ? _vm._i(success.state, null) > -1
                                        : success.state
                                    },
                                    on: {
                                      change: function($event) {
                                        var $$a = success.state,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                success,
                                                "state",
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                success,
                                                "state",
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(success, "state", $$c)
                                        }
                                      }
                                    }
                                  })
                                ]
                              )
                            })
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "row" },
                          [
                            _c("div", { staticClass: "col-6" }, [
                              _vm._v("Failures")
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.sheet.death_saves.failures, function(
                              failure
                            ) {
                              return _c(
                                "div",
                                {
                                  key: failure.state,
                                  staticClass: "col-2 death-save"
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: failure.state,
                                        expression: "failure.state"
                                      }
                                    ],
                                    attrs: { type: "checkbox" },
                                    domProps: {
                                      checked: Array.isArray(failure.state)
                                        ? _vm._i(failure.state, null) > -1
                                        : failure.state
                                    },
                                    on: {
                                      change: function($event) {
                                        var $$a = failure.state,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                failure,
                                                "state",
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                failure,
                                                "state",
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(failure, "state", $$c)
                                        }
                                      }
                                    }
                                  })
                                ]
                              )
                            })
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _vm._m(11)
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row attacks-and-spellcasting-block" }, [
              _c("div", { staticClass: "col-12" }, [
                _c(
                  "div",
                  { staticClass: "row attacks-and-spellcasting-container" },
                  [
                    _c(
                      "div",
                      { staticClass: "col-12", attrs: { id: "attacks-table" } },
                      [
                        _vm._m(12),
                        _vm._v(" "),
                        _vm._l(_vm.sheet.attacks, function(attack) {
                          return _c(
                            "div",
                            {
                              key: attack.id,
                              staticClass: "row",
                              attrs: { value: attack.name }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "col-5 input-section attack-name"
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: attack.name,
                                        expression: "attack.name"
                                      }
                                    ],
                                    domProps: { value: attack.name },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          attack,
                                          "name",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-2 input-section" },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: attack.bonus,
                                        expression: "attack.bonus"
                                      }
                                    ],
                                    domProps: { value: attack.bonus },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          attack,
                                          "bonus",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-5 input-section attack-dmg-type"
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: attack.dmg_and_type,
                                        expression: "attack.dmg_and_type"
                                      }
                                    ],
                                    domProps: { value: attack.dmg_and_type },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          attack,
                                          "dmg_and_type",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ]
                              )
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "row",
                            attrs: { id: "attacks-and-spellcasting-text" }
                          },
                          [
                            _c("div", { staticClass: "col-12 text-section" }, [
                              _c("textarea", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.sheet.attacks_text,
                                    expression: "sheet.attacks_text"
                                  }
                                ],
                                domProps: { value: _vm.sheet.attacks_text },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.sheet,
                                      "attacks_text",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _vm._m(13)
                      ],
                      2
                    )
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row equipment-block" }, [
              _c("div", { staticClass: "col-12" }, [
                _c("div", { staticClass: "row equipment-container" }, [
                  _c(
                    "div",
                    { staticClass: "col-3" },
                    _vm._l(_vm.COINS, function(coin) {
                      return _c(
                        "div",
                        {
                          key: coin.short,
                          staticClass: "row coin",
                          attrs: { value: coin.short }
                        },
                        [
                          _c("div", { staticClass: "col-3 coin-label" }, [
                            _vm._v(_vm._s(coin.short))
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-9 coin-text text-section" },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.sheet[coin.short.toLowerCase()],
                                    expression:
                                      "sheet[coin.short.toLowerCase()]"
                                  }
                                ],
                                domProps: {
                                  value: _vm.sheet[coin.short.toLowerCase()]
                                },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.sheet,
                                      coin.short.toLowerCase(),
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ]
                          )
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-9" }, [
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        {
                          staticClass: "col-12 text-section",
                          attrs: { id: "equipment" }
                        },
                        [
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.sheet.equipment,
                                expression: "sheet.equipment"
                              }
                            ],
                            domProps: { value: _vm.sheet.equipment },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.sheet,
                                  "equipment",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]
                      )
                    ]),
                    _vm._v("\n                  Equipment\n                ")
                  ])
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-4 right-column" }, [
            _c("div", { staticClass: "row background-block" }, [
              _c("div", { staticClass: "col-12" }, [
                _c("div", { staticClass: "row background-container" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c("div", { staticClass: "row personality-traits" }, [
                      _c("div", { staticClass: "col text-section" }, [
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.sheet.personality_traits,
                              expression: "sheet.personality_traits"
                            }
                          ],
                          domProps: { value: _vm.sheet.personality_traits },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.sheet,
                                "personality_traits",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(
                          "\n                      Personality Traits\n                    "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row ideals" }, [
                      _c("div", { staticClass: "col text-section" }, [
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.sheet.ideals,
                              expression: "sheet.ideals"
                            }
                          ],
                          domProps: { value: _vm.sheet.ideals },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(_vm.sheet, "ideals", $event.target.value)
                            }
                          }
                        }),
                        _vm._v(
                          "\n                      Ideals\n                    "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row bonds" }, [
                      _c("div", { staticClass: "col text-section" }, [
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.sheet.bonds,
                              expression: "sheet.bonds"
                            }
                          ],
                          domProps: { value: _vm.sheet.bonds },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(_vm.sheet, "bonds", $event.target.value)
                            }
                          }
                        }),
                        _vm._v(
                          "\n                      Bonds\n                    "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row flaws" }, [
                      _c("div", { staticClass: "col text-section" }, [
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.sheet.flaws,
                              expression: "sheet.flaws"
                            }
                          ],
                          domProps: { value: _vm.sheet.flaws },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(_vm.sheet, "flaws", $event.target.value)
                            }
                          }
                        }),
                        _vm._v(
                          "\n                      Flaws\n                    "
                        )
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row features-and-traits-block" }, [
              _c("div", { staticClass: "col-12" }, [
                _c(
                  "div",
                  { staticClass: "row features-and-traits-container" },
                  [
                    _c("div", { staticClass: "col-12 text-section" }, [
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.sheet.features_and_traits,
                            expression: "sheet.features_and_traits"
                          }
                        ],
                        domProps: { value: _vm.sheet.features_and_traits },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.sheet,
                              "features_and_traits",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(
                        "\n                  Features & Traits\n                "
                      )
                    ])
                  ]
                )
              ])
            ])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { attrs: { id: "charsheet-data-json" } }, [
      _vm._v("\n    Raw character sheet data (as JSON)\n    "),
      _c("p", [
        _vm._v(
          "You can copy this, save it somewhere else, and then paste it back here to populate the sheet above."
        )
      ]),
      _vm._v(" "),
      _c("textarea", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.sheet_json,
            expression: "sheet_json"
          }
        ],
        domProps: { value: _vm.sheet_json },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.sheet_json = $event.target.value
          }
        }
      })
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [_vm._v("Character Name")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row char-info-label-row" }, [
      _c("div", { staticClass: "col-4" }, [_vm._v("Class & Level")]),
      _vm._v(" "),
      _c("div", { staticClass: "col-4" }, [_vm._v("Background")]),
      _vm._v(" "),
      _c("div", { staticClass: "col-4" }, [_vm._v("Player Name")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row char-info-label-row" }, [
      _c("div", { staticClass: "col-4" }, [_vm._v("Race")]),
      _vm._v(" "),
      _c("div", { staticClass: "col-4" }, [_vm._v("Alignment")]),
      _vm._v(" "),
      _c("div", { staticClass: "col-4" }, [_vm._v("Experience Points")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [_vm._v("Savings Throws")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [_vm._v("Skills")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [_vm._v("AC")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [_vm._v("Initiative")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [_vm._v("Speed")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row hp-current-label" }, [
      _c("div", { staticClass: "col-12" }, [_vm._v("Current Hit Points")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row temp-hp-label" }, [
      _c("div", { staticClass: "col-12" }, [_vm._v("Temporary Hit Points")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [_vm._v("Hit dice")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [_vm._v("Death Saves")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-5" }, [
        _vm._v("\n                      Name\n                    ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-2" }, [
        _vm._v("\n                      Atk bonus\n                    ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-5" }, [
        _vm._v("\n                      Dmg/Type\n                    ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [_vm._v("Attacks & Spellcasting")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5ceb06e6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ceb06e6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CharacterSheet.vue
// module id = null
// module chunks = 